<template>
  <div class="headers">
    <div class="paddings075">
      <router-link to="/phoneindex" class="left-logo">
        <i class="logo"></i>
        <span class="title">Yedeer</span>
      </router-link>
      <div class="centers">
        <YedeerStepPhone></YedeerStepPhone>
      </div>
      <div class="rights">
        <a class="btn" @click="getURLScheme()">Login / Sign Up</a>
      </div>
    </div>
  </div>
</template>

<script>
// 引入组件
import YedeerStepPhone from "@/components/YedeerStepPhone/YedeerStepPhone.vue";
import { Admin } from "@/api";
export default {
  name: "YHeaderPhone",
  components: { YedeerStepPhone },
  methods: {
    towhat(what) {
      if (what === "login") {
        this.$router.push("/login");
      } else if (what === "sign") {
        this.$router.push("/register");
      }
    },
    async getURLScheme() {
      debugger
      let wxAppletUrl = await Admin.getURLScheme({});
      location.href = wxAppletUrl.data.openlink;
    },
  },
};
</script>

<style lang="less" scoped>
a {
  text-decoration: none;
}
.headers {
  // padding: 0 0.75rem;
  max-height: 1.38rem;
  box-sizing: border-box;
  .paddings075 {
    padding: 0 0.75rem;
    max-height: 1.38rem;
    // background-color: #c00;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-logo {
      display: flex;
      align-items: center;
      .logo {
        width: 1.38rem;
        height: 1.38rem;
        display: block;
        background: url(@/assets/images/logo.svg) no-repeat center center/cover;
      }
      .title {
        font-family: ArialRoundedmt;
        font-size: 0.63rem;
        color: #242424;
        letter-spacing: 0.01rem;
        margin-left: 0.25rem;
      }
    }
    .rights {
      font-family: ArialRoundedmt;
      font-size: 0.5rem;
      color: #000000;
      display: flex;
      align-items: center;
      // background-color: #fff;
      text-align: center;

      .btn {
        width: 6.88rem;
        height: 1.25rem;
        line-height: 1.25rem;
        color: #fff;
        background: #135ce7;
        border-radius: 0.2rem;
        margin-left: 0.69rem;
      }
    }
  }
}
</style>
